import { withStyles, Grid } from '@material-ui/core'
import CloseIcon from 'mdi-react/CloseIcon'
import moment from 'moment-timezone'
import { Field } from 'redux-form'
import { FormShowing } from '../../../types/showings'
import { required } from '../../../utils/validation/forms'

moment.tz.setDefault('Europe/Helsinki')

const styles = () => ({
  close: {
    background: 'none',
    outline: 'none',
    border: 0,
    cursor: 'pointer',
    verticalAlign: 'middle'
  },
  newShowingLists: {
    listStyleType: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column' as const
  },
  newShowingList: {
    border: '1px solid #E8E8E8',
    padding: '0.8rem 1rem',
    background: 'white'
  },
  showingTypeContainer: {
    marginTop: '7px'
  }
})

const Paraghraph = ({ input: { value }, extractDate = false }: any) => {
  const getDate = moment(value).format('DD.MM.YYYY')
  const getTime = moment(value).format('HH:mm')
  return extractDate ? <strong>{getDate}</strong> : <span>{getTime}</span>
}

/** todo, handle data from form values instead. input can break */
const ShowingFields = ({ fields, classes, t, showingType }: any) => (
  <ul className={classes.newShowingLists}>
    {fields.map((showing: FormShowing, index: number) => {
      return (
        <li key={index} className={classes.newShowingList}>
          <Grid container direction='column'>
            <Grid
              container
              item
              xs={12}
              md={undefined}
              direction='row'
              justify='space-between'
            >
              <Grid item>
                <Field
                  fullWidth
                  name={`${showing}.startDate`}
                  validate={[required]}
                  component={Paraghraph}
                  extractDate
                />
              </Grid>
              <Grid item>
                <Field
                  fullWidth
                  name={`${showing}.startDate`}
                  validate={[required]}
                  component={Paraghraph}
                />
                <span>-</span>
                <Field
                  fullWidth
                  name={`${showing}.endDate`}
                  validate={[required]}
                  component={Paraghraph}
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              md={undefined}
              direction='row'
              justify='space-between'
              className={classes.showingTypeContainer}
            >
              <Grid item>
                {/*
                <Typography style={{ color: '#5C6DCE', fontWeight: 'bold' }}>
                  {t(`showings.createShowings.${showingType}`)}
                </Typography>
                */}
              </Grid>
              <Grid item>
                <button
                  type='button'
                  className={classes.close}
                  title='Remove showing'
                  onClick={() => fields.remove(index)}
                >
                  <CloseIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>
        </li>
      )
    })}
  </ul>
)

export default withStyles(styles)(ShowingFields) as any
